module.exports = __webpack_public_path__ + "static/media/23-2.648b5792.mp3";